import React from "react";
import { Box, Container, Typography, Link, Stack } from "@mui/material";
import { fireGAEvent } from "../lib/gtag.js";

export default function BBFFooter() {
  const handleLinkClick = (label, screen) => {
    fireGAEvent("footer_link_click", {
      event_category: "LegalDocs",
      event_label: label,
      screen_name: screen,
    });
  };

  return (
    <Box component="footer" sx={{ py: 4, bgcolor: "#111", color: "#fff", textAlign: "center" }}>
      <Container maxWidth="md">
        <Stack direction={{ xs: "column", sm: "row" }} spacing={3} justifyContent="center">
          <Link
            href="/contact"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => handleLinkClick("Contact Us", "BBFFooter::Contact")}
            underline="hover"
            color="inherit"
          >
            Contact Us
          </Link>
          <Link
            href="/docs/soar_terms-of-use.pdf"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => handleLinkClick("Terms of Use PDF", "BBFFooter::TermsOfUse")}
            underline="hover"
            color="inherit"
          >
            Terms of Use
          </Link>

          <Link
            href="/docs/soar_privacy-policy.pdf"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => handleLinkClick("Privacy Policy PDF", "BBFFooter::PrivacyPolicy")}
            underline="hover"
            color="inherit"
          >
            Privacy Policy
          </Link>

          <Link
            href="/docs/soar_communications-policy.pdf"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => handleLinkClick("Communications Policy PDF", "BBFFooter::Communications")}
            underline="hover"
            color="inherit"
          >
            Communications Policy
          </Link>
        </Stack>
        <Typography variant="body2" sx={{ mt: 2 }}>
          &copy; {new Date().getFullYear()} Spirit of America – Rising LLC. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
}
